import {
  APP_ID_LOGGING_SERVICE, APP_ID_NG_CASB,
  APP_ID_PRISMA_ACCESS, APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_SDWAN,
  CTX_CDL
} from '../../../../common/constants/GlobalConstants'

export const AGREE_TERMS_PREFIX = 'Agree to the '
export const BUTTON_ACTIVATE_NOW = 'Activate Now'
export const LINK_TERMS = 'Terms and Conditions'
export const ACTIVATE_TOOLTIP_NO_MSG = 'Click to Activate License'
export const TOOLTIP_ACTIVATE_BUTTON = 'Activate will assign all license quantity to this tenant. If you wish to split or share the license, refresh the browser and select “Multi-Tenant Cloud Managed”.'
export const LICENSE_CONTEXT_TO_APP_ID = {
  [CTX_CDL]: APP_ID_LOGGING_SERVICE,
  [APP_ID_SDWAN]: APP_ID_SDWAN,
  [APP_ID_PRISMA_ACCESS]: APP_ID_PRISMA_ACCESS_EDITION,
  [APP_ID_NG_CASB]: APP_ID_NG_CASB
}
export const ALLOWED_LICENSE_CONTEXTS = [APP_ID_SDWAN, CTX_CDL, APP_ID_NG_CASB]
